<script>
import moment from 'moment'
import { format, parseISO } from 'date-fns'
import layout from '@src/mixins/layout.vue'
import ProviderListFiltersComponent from '@/src/components/provider-list-filters-component.vue'
import ProviderListSortComponent from '@/src/components/provider-list-sort-component.vue'
import TimeTile from '@components/time-tile.vue'
import ProviderDetails from '@views/safehaven/health-help/telehealth/provider-details.vue'
import { providerService } from '@/src/services/safehaven/ProviderService'
import { peerCoachingService } from '@services/safehaven/PeerCoachingService'
import NavigateMixin from '@src/mixins/navigate-mixin.vue'
import { EventBus } from '../../../../../../../src/event-bus'

export default {
  page: {
    title: 'Provider List',
    meta: [{ name: 'description', content: 'The provider list page.' }],
  },
  components: {
    ProviderListFiltersComponent,
    TimeTile,
    ProviderListSortComponent,
    ProviderDetails,
  },
  mixins: [layout, NavigateMixin],
  data() {
    return {
      date: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      currentDateWithFormat: new Date()
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, '-'),
      selectDate: null,
      selectedDate: null,
      selectedProvider: null,
      selectedProviderId: null,
      selectedGender: '',
      selectedLanguage: '',
      selectedSortOption: 'asc',
      showProviderDetails: false,
      providerId: 0,
      selectedProviderDetails: {},
      providers: [],
      label: 'Select type of provider',
      timeSlots: [],
      loading: false,
      completeProviderList: [],
      providerList: [],
      providerListReqObj: {
        provider_type: '',
        date: '',
        provider_id: '',
        sort: {
          field: '',
          order: 'asc',
        },
        filter: {
          gender: '',
          language: '',
        },
      },
      providerDetailReqObj: {
        provider_type: '',
        date: '',
        provider_id: 0,
      },
      nOD: moment().format('MMMM D'),
      todayDate: moment().format('MMMM D'),
      now: moment().format('YYYY-MM-DD').toString(),
      isTimeBefore: true,
      navData: {},
      showDisplayMoreButton: false,
      noActiveTimeSlotAvailable: false,
      activeSlotsArr: [],
    }
  },
  computed: {
    computedDateFormatted() {
      if (this.currentDateWithFormat === this.date) {
        return this.date
          ? moment(this.date).format('[Today], MMMM Do YYYY')
          : ''
      } else {
        return this.date ? moment(this.date).format('dddd, MMMM Do YYYY') : ''
      }
    },
  },

  watch: {
    date(val) {
      this.selectedDate = val
      this.nOD = moment(val).format(' MMMM D')
      this.selectDate = false
    },
  },
  updated: function () {
    this.isTimeBefore = moment(this.selectedDate).isBefore(this.now)
  },

  async mounted() {
    EventBus.$on('route-pushed', this.handleCalendarEvent)

    this.init()
  },
  methods: {
    handleCalendarEvent(params) {
      this.navData = params
      this.init()
    },

    async init() {
      if (!this.navData.loadDetails) {
        this.navData = this.$route.params
      }
      try {
        const providerData = (await peerCoachingService.getReasonProviderType())
          .data

        if (this.navData.selectedProvider) {
          this.providers = providerData.provider_type
          this.selectedProvider = this.navData.selectedProvider
          this.selectedProviderId = this.navData.selectedProviderId || null
          this.date = moment(this.navData.selectedDate)
            .format('YYYY-MM-DD')
            .toString()
          this.selectedDate = this.date
        } else if (providerData) {
          this.providers = providerData.provider_type
          this.selectedProvider = this.providers[0].provider_type
          this.selectedProviderId = this.providers[0].id
          this.selectedDate = moment().format('YYYY-MM-DD').toString()
        }
        this.getUpdatedProviderList()
      } catch (error) {
        console.warn(error.response)
      }
    },

    getUpdatedProviderList() {
      this.loading = true
      this.providerListReqObj = {
        provider_type: this.selectedProvider,
        date: this.selectedDate,
        sort: {
          field: 'first_name',
          order: this.selectedSortOption,
        },
        filter: {
          gender: this.selectedGender,
          language: '',
        },
      }
      providerService
        .getProviderList(this.providerListReqObj)
        .then((res) => {
          this.providerList = this.parseResponse(res.data)
          this.completeProviderList = this.providerList
          if (this.providerList.length > 15) {
            this.showDisplayMoreButton = true
            this.providerList = this.completeProviderList.splice(0, 15)
          } else {
            this.showDisplayMoreButton = false
          }
          this.loading = false

          if (this.navData.loadDetails) {
            this.getUpdatedProviderDetails()
          }
        })
        .catch((error) => {
          console.warn(error)

          this.loading = false
          this.providerList = []
        })
    },
    getUpdatedProviderDetails() {
      this.providerDetailReqObj = {
        provider_type: this.selectedProvider,
        date: this.selectedDate,
        provider_id: this.selectedProviderDetails.provider_id,
      }

      if (this.navData.loadDetails) {
        this.providerDetailReqObj.provider_id =
          this.navData.selectedProviderDetailsId
      }

      providerService
        .getProviderDetails(this.providerDetailReqObj)
        .then((res) => {
          const response = this.parseResponse(res.data)
          this.selectedProviderDetails = response[0]
          this.showProviderDetails = true
          this.$forceUpdate()
          this.navData.loadDetails = false
        })
    },
    selectProvider() {
      this.providers.map((provider) => {
        if (this.selectedProvider === provider.provider_type) {
          this.selectedProviderId = provider.id
        }
      })
    },
    applyFilter(filterData) {
      this.selectedGender = filterData.gender[0] || ''
      this.selectedLanguage = filterData.language
      this.getUpdatedProviderList()
    },
    applySort(sortOption) {
      this.selectedSortOption = sortOption
      this.getUpdatedProviderList()
    },
    showMoreProviders() {
      this.providerList = this.providerList.concat(this.completeProviderList)
      this.showDisplayMoreButton = false
    },
    showDialog(index) {
      this.selectedProviderDetails = this.providerList[index]
      this.getUpdatedProviderDetails()
    },
    dismissDialog() {
      this.showProviderDetails = false
    },
    searchProvider() {
      this.getUpdatedProviderList()
    },
    parseResponse(resData) {
      resData.map((provider) => {
        provider.credArr = provider.credentials
        provider.credentials = this.getCredentials(provider.credentials)

        this.activeSlotsArr = []
        if (
          provider.available_slots.slot &&
          provider.available_slots.slot.length > 0
        ) {
          provider.available_slots.slot.map((slot) => {
            if (!this.pastTimeCheck(this.selectedDate, slot.start_time)) {
              this.activeSlotsArr.push(slot)
            }
          })
        }

        if (this.activeSlotsArr.length > 0) {
          let slotsForMobile = []
          let slotsForDesktop = []
          if (this.activeSlotsArr.length > 4) {
            const slotArr = this.activeSlotsArr.slice()
            slotsForMobile = slotArr.splice(0, 4)
          } else {
            slotsForMobile = this.activeSlotsArr
          }

          if (this.activeSlotsArr.length > 10) {
            const slotArr = this.activeSlotsArr.slice()
            slotsForDesktop = slotArr.splice(0, 10)
          } else {
            slotsForDesktop = this.activeSlotsArr
          }
          if (this.activeSlotsArr.length > 10) {
            provider.showViewMoreDesktop = true
          } else {
            provider.showViewMoreDesktop = false
          }
          if (this.activeSlotsArr.length > 4) {
            provider.showViewMoreMobile = true
          } else {
            provider.showViewMoreMobile = false
          }
          provider.slotsForMobile = slotsForMobile
          provider.slotsForDesktop = slotsForDesktop
        } else {
          provider.available_slots.slot = []
        }
      })
      return resData
    },
    getCredentials(credArr) {
      let credentials = ''
      credArr.map((cred) => {
        credentials = credentials + ', ' + cred.credential_name
      })
      return credentials
    },
    bookMeeting(timeSlot, provider) {
      this.selectedProviderDetails = provider
      this.selectedProviderDetails.selectedTimeSlot = timeSlot
      this.selectedProviderDetails.selectedDate = this.selectedDate

      this.$router.push({
        name: 'confirm-appointment',
        params: { selectedProviderDetails: this.selectedProviderDetails },
      })
    },
    nextDate() {
      this.selectedDate = moment(this.selectedDate)
        .add(1, 'days')
        .format('YYYY-MM-DD')
        .toString()
      this.nOD = moment(this.selectedDate).format('MMMM D')
      this.date = this.selectedDate
      this.getUpdatedProviderList()
    },
    previousDate() {
      this.selectedDate = moment(this.selectedDate)
        .add(-1, 'days')
        .format('YYYY-MM-DD')
        .toString()
      this.nOD = moment(this.selectedDate).format('MMMM D')
      this.date = this.selectedDate

      this.getUpdatedProviderList()
    },
    pastTimeCheck(localDate, timeSlot) {
      const now = moment().format('YYYY-MM-DD HH:mm:ss').toString()

      // Converting Selected time slot to 24hr format and removing AM/PM from end
      let timeSlotArr = []
      if (timeSlot.includes('AM')) {
        timeSlot = timeSlot.replace(' AM', ':00')
      } else if (timeSlot.includes('PM')) {
        timeSlot = timeSlot.replace(' PM', ':00')
        timeSlotArr = timeSlot.split(':')
        if (timeSlotArr[0] < 12) {
          const hour = parseInt(timeSlotArr[0]) + 12
          timeSlot = hour + ':' + timeSlotArr[1] + ':00'
        }
      }

      const timeSlotString = localDate + ' ' + timeSlot
      const selectedTime = moment(timeSlotString)
      const currentTime = moment(now)
      if (selectedTime < currentTime) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>

<template>
  <div :class="$style.mainContainer">
    <ProviderDetails
      :show-details="showProviderDetails"
      :provider-details="selectedProviderDetails"
      :selected-date="selectedDate || ''"
      @close-dialog="dismissDialog"
    />
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="3"
        xl="4"
        :class="$style.paddingSelect"
        :align="notDesktop ? 'center' : 'start'"
        fill-height
      >
        <v-select
          v-model="selectedProvider"
          :class="$style.selectorclss"
          :items="providers"
          item-text="provider_type"
          item-value="key"
          class="mt-6 mb-1"
          dense
          :placeholder="label"
          outlined
          @change="selectProvider"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="3"
        xl="4"
        :class="$style.paddingDate"
        :align="notDesktop ? 'center' : 'start'"
        fill-height
      >
        <v-menu
          v-model="selectDate"
          :close-on-content-click="false"
          max-width="290"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="computedDateFormatted"
              append-icon="mdi-calendar"
              outlined
              dense
              v-bind="attrs"
              v-on="on"
              @click:append="on.click"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            :min="new Date().toISOString().substr(0, 10)"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <div
        cols="12"
        sm="12"
        md="12"
        lg="3"
        xl="4"
        :class="$style.searchRow"
        fill-height
      >
        <v-btn
          color="#0476D9"
          rounded
          medium
          :class="$style.searchBtn"
          @click="searchProvider"
        >
          <v-icon color="white" :size="30" :class="$style.searchIcon"
            >mdi-magnify</v-icon
          >
        </v-btn>
        <div v-if="notDesktop" :class="$style.filterContainer">
          <ProviderListSortComponent
            @sort-applied="applySort"
          ></ProviderListSortComponent>
          <div :class="$style.vl" />
          <ProviderListFiltersComponent
            @filter-applied="applyFilter"
          ></ProviderListFiltersComponent>
        </div>
      </div>
    </v-row>
    <v-row :class="$style.sortFilterOption">
      <div :class="$style.dateSlider">
        <v-carousel hide-delimiters :class="$style.carouselContaner">
          <template v-slot:prev="{ on, attrs }">
            <v-icon
              color="#0476D9"
              style="background-color: #f2f9ff"
              size="30"
              v-bind="attrs"
              v-on="on"
              @click="previousDate"
              >mdi-less-than</v-icon
            >
          </template>
          <template v-slot:next="{ on, attrs }">
            <v-icon
              color="#0476D9"
              style="background-color: #f2f9ff"
              size="30"
              v-bind="attrs"
              v-on="on"
              @click="nextDate"
              >mdi-greater-than</v-icon
            >
          </template>
          <v-carousel-item v-for="(item, i) in nOD" :key="i">
            <v-row :class="$style.carouselItem" align="center" justify="center">
              <div>
                <span v-if="todayDate === nOD">Today, </span>
                {{ nOD }}</div
              >
            </v-row>
          </v-carousel-item>
        </v-carousel>
      </div>
      <div v-if="!notDesktop" :class="$style.filterContainer">
        <ProviderListSortComponent
          @sort-applied="applySort"
        ></ProviderListSortComponent>
        <div :class="$style.vl" />
        <ProviderListFiltersComponent
          @filter-applied="applyFilter"
        ></ProviderListFiltersComponent>
      </div>
    </v-row>
    <v-row :class="$style.listContainer">
      <v-sheet
        v-if="loading"
        :color="`white `"
        class="pa-3"
        :class="$style.liststyle"
      >
        <v-skeleton-loader
          class="mx-auto"
          max-width="300"
          type="list-item-three-line, list-item-three-line, list-item-three-line"
        ></v-skeleton-loader>
      </v-sheet>
      <v-list
        v-if="loading === false && providerList.length > 0"
        three-line
        :class="$style.liststyle"
      >
        <div v-for="(provider, index) in providerList" :key="index">
          <div>
            <div :class="$style.listItemContainer">
              <v-row :class="$style.topContainer">
                <div>
                  <v-img
                    class="rounded-lg mt-2"
                    :class="$style.providerImage"
                    contain
                    :src="
                      provider.profile_picture_url === ''
                        ? require('@assets/images/safehaven/sample_avatar.jpg')
                        : provider.profile_picture_url
                    "
                    alt=""
                  >
                  </v-img>
                </div>
                <div>
                  <div :class="$style.textContainer">
                    <p
                      :class="$style.appointmentText"
                      @click="showDialog(index)"
                    >
                      {{ provider.first_name }} {{ provider.last_name
                      }}{{ provider.credentials }}
                    </p>
                    <p :class="$style.titleText">
                      {{ provider.speciality }}
                    </p>
                    <p> {{ provider.city }}, {{ provider.state }}</p>
                  </div>
                </div>
              </v-row>
              <div
                v-if="
                  !isTimeBefore &&
                  provider.available_slots &&
                  provider.available_slots.slot &&
                  provider.available_slots.slot.length > 0
                "
                :class="$style.timeSlotRow"
              >
                <div v-if="notDesktop" :class="$style.tileWrapper">
                  <TimeTile
                    v-for="(timeSlot, ind) in provider.slotsForMobile"
                    :key="ind"
                    :time-slot="timeSlot.start_time"
                    :selected-date="provider.available_slots.date"
                    :is-booked="timeSlot.isBooked"
                    @time-selected="bookMeeting(timeSlot, provider)"
                  />
                </div>
                <div v-else :class="$style.tileWrapper">
                  <TimeTile
                    v-for="(timeSlot, ind) in provider.slotsForDesktop"
                    :key="ind"
                    :time-slot="timeSlot.start_time"
                    :selected-date="provider.available_slots.date"
                    :is-booked="timeSlot.isBooked"
                    @time-selected="bookMeeting(timeSlot, provider)"
                  />
                </div>
                <p
                  v-if="!notDesktop && provider.showViewMoreDesktop"
                  :class="$style.viewAllText"
                >
                  <a @click="showDialog(index)">View all </a>
                </p>
                <p v-if="notDesktop" :class="$style.viewAllText">
                  <a @click="showDialog(index)">View all </a>
                </p>
              </div>
              <div
                v-if="provider.available_slots.slot.length === 0"
                :class="$style.timeSlotRow"
              >
                <p :class="$style.viewAllText"> No availability </p>
              </div>
            </div>
            <div :class="$style.separater"></div>
          </div>
        </div>
      </v-list>
      <div :class="$style.bottomTextCont">
        <p
          v-if="!loading && providerList.length === 0"
          :class="$style.noProviderText"
        >
          No providers found
        </p>

        <p :class="$style.termsText">
          During the telehealth meeting, your personal health information will
          be securely shared with the provider.
          <router-link :to="{ name: 'healthbookplus-privacy' }"
            >View Privacy Policy</router-link
          >
        </p>
      </div>
    </v-row>
    <div
      v-if="!loading && showDisplayMoreButton"
      :class="$style.tile"
      @click="showMoreProviders"
    >
      <p :class="$style.timeText"> Display more </p>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.textTransform {
  text-transform: unset !important;
}

.imgWidth {
  width: 100%;
}

.mainContainer {
  width: 97%;
  margin-top: 10px;
  margin-right: auto;
  margin-left: auto;
}

.paddingSelect {
  padding-top: 1px !important;
  padding-left: 15px !important;
}

.paddingDate {
  min-width: 350px;
  padding-top: 24px !important;
  padding-left: 15px !important;
  cursor: pointer;
}

.searchRow {
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 20px !important;
  padding-left: 15px !important;
  margin-bottom: 10px;
}

.dateSlider {
  display: flex;
  flex: 1;
  justify-content: left;
}

.searchBtn {
  margin-top: 5px !important;
}

.searchIcon {
  padding: 5px 0 2px 0 !important;
}

.dateText {
  margin-bottom: 5px !important;
  font-size: 18px;
  font-weight: 700;
  line-height: 150%;
  color: #000;
  text-align: center;
  background-color: transparent !important;
}

.filterContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
}

.sortFilterOption {
  align-items: flex-start;
  justify-content: space-between;
  height: 40px;
  font-size: 15px;
  font-weight: 500;
  line-height: 24px;
  color: rgb(176, 176, 182);
  letter-spacing: 0.75px;
}

.vl {
  height: 50%;
  margin-top: 5px;
  border-right: 3px solid rgb(206, 206, 206);
}

.listContainer {
  width: 103%;
  margin-left: -22px;
  border: 1px solid #d1dfeb;
}

.liststyle {
  width: 100%;
}

.listItemContainer {
  padding-left: 20px;
}

.topContainer {
  display: flex;
  flex-direction: row;
  padding: 10px;
  padding-left: 20px;
  margin-bottom: 5px;
}

.providerImage {
  width: 130px;
  height: 100px;
}

.textContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 10px;
  overflow: hidden;
  text-align: left;
}

.titleText {
  margin-bottom: 0 !important;
  font-size: 15px;
  font-weight: 700;
  line-height: 150%;
  color: #2c3a4b;
}

.appointmentText {
  width: 600px;
  margin-bottom: 0 !important;
  font-size: 18px;
  font-weight: 700;
  line-height: 30px;
  color: #09101d;
  letter-spacing: -0.3px;
  cursor: pointer;
}

.timeSlotRow {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  padding: 5px;
  padding-left: 10px;
  margin-top: -25px;
  margin-right: 2px;
  margin-left: 1px;
}

.viewAllText {
  margin-top: 25px;
  margin-left: 10px;
  font-size: 15px;
  font-weight: 400;
  line-height: 23px;
  color: #0476d9;
  text-align: left;
  letter-spacing: 0;
}

.separater {
  width: 100%;
  height: 1px;
  margin-top: 10px;
  margin-bottom: 10px;
  background-color: #d1dfeb;
}

.tileWrapper {
  display: flex;
}

.tile {
  width: 10%;
  height: 40px;
  padding: 3px;
  margin-top: 50px;
  margin-bottom: 50px;
  cursor: pointer;
  background: #fff;
  border: 2px solid #0476d9;
  border-radius: 6px;
}

.timeText {
  font-size: 14px;
  font-weight: 600;
  line-height: 30px;
  color: #0476d9;
  text-align: center;
}

.carouselContaner {
  width: 30%;
  height: 50px !important;
  padding-left: 15px;
}

.carouselItem {
  margin-top: 5px;
  font-size: 18px;
  font-weight: 700;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0;
}

.noProviderText {
  font-size: 18px;
  font-weight: 700;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0;
}

.bottomTextCont {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.termsText {
  margin-top: 10px;
  margin-bottom: 16px !important;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  letter-spacing: 0;
}

@media screen and (max-width: 1263px) {
  .paddingSelect {
    padding-left: 0 !important;
  }
}

@media screen and (max-width: 959px) {
  .paddingSelect {
    padding: 0 20px !important;
  }

  .paddingDate {
    padding: 0 20px !important;
    margin-top: -15px;
  }

  .searchRow {
    padding: 5px 30px !important;
    margin-top: -20px;
  }

  .listContainer {
    margin-left: -5px;
  }

  .carouselContaner {
    width: 100%;
  }

  .tile {
    width: 30%;
  }

  .dateSlider {
    justify-content: center;
  }

  .listItemContainer {
    padding-left: 0;
  }

  .appointmentText {
    font-size: 16px;
  }

  .viewAllText {
    margin-left: 10px;
  }

  .textContainer {
    width: 400px;
  }

  .bottomTextCont {
    padding: 10px;
  }
}

@media screen and (max-width: 550px) {
  .textContainer {
    display: block;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
